import React, { useEffect } from "react";
import { getServerSideProps } from "../src/utils/getServerSideProps";
import { useRouter } from "next/router";

const SignupPage: React.FC<{ body?: { code?: string; state?: string } }> =
  () => {
    const router = useRouter();

    useEffect(() => {
      router.replace("onboarding");
    }, []);

    return null;
  };

export default SignupPage;
export { getServerSideProps };
